import React, { createContext, useContext, useState } from 'react'

interface ModalContextType {
  modalStatus: boolean
  setModalStatus: (status: boolean) => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [modalStatus, setModalStatus] = useState(false)

  return (
    <ModalContext.Provider value={{ modalStatus, setModalStatus }}>
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider')
  }
  return context
}
